import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { trackError } from '../utils/analytics';
import Button from '../components/Button';

type Props = {
  isOpen: boolean;
  message?: string;
  onClose: () => void;
  errorType?: 'api' | 'validation' | 'client' | 'server';
  componentName?: string;
  isFatal?: boolean;
};

const ErrorModal: React.FC<Props> = ({
  isOpen,
  message,
  onClose,
  errorType = 'client',
  componentName,
  isFatal = false
}) => {

  // Rastreia o erro no Google Analytics quando o modal é aberto
  useEffect(() => {
    if (isOpen && message) {
      trackError(
        errorType,
        message,
        isFatal,
        componentName
      );
    }
  }, [isOpen, message, errorType, componentName, isFatal]);

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header
        closeButton
        onClick={onClose}
        className="bg-white"
        style={{
          border: 0,
          borderRadius: 0,
          padding: 20,
          borderTopLeftRadius: 10,
          WebkitBorderTopRightRadius: 10,
        }}
      />
      <Modal.Body
        className="bg-white"
        style={{
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <p className="font-xs text-black">{message}</p>
        <div className="form-group mb-1">
          <Button
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;
